import React from 'react';
import './Settings.css';

const Settings = ({ isOpen, onClose, theme, onThemeChange }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="SettingsOverlay" onClick={onClose} />
      <div className="SettingsDialog">
        <div className="SettingsHeader">
          <h2>Settings</h2>
          <button className="SettingsCloseButton" onClick={onClose} aria-label="Close settings">
            ×
          </button>
        </div>
        <div className="SettingsContent">
          <div className="SettingsSection">
            <label className="SettingsLabel">Theme</label>
            <div className="ThemeToggle">
              <button
                className={`ThemeOption ${theme === 'light' ? 'active' : ''}`}
                onClick={() => onThemeChange('light')}
              >
                Light
              </button>
              <button
                className={`ThemeOption ${theme === 'dark' ? 'active' : ''}`}
                onClick={() => onThemeChange('dark')}
              >
                Dark
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;

